import { TableOrdering } from "utils/tables/createContent";
import DateUtils from "utils/dates/DateUtils";
import { sortByDayAndMonthAndYear } from "utils/sort/sortByDate";
import { compareStrings } from "utils/sort/strings";

export function desc(a, b, attribute) {
  if (a[attribute] === null || a[attribute] === undefined) {
    a[attribute] = "";
  }

  if (b[attribute] === null || b[attribute] === undefined) {
    b[attribute] = "";
  }

  if (attribute === "admissionDate") {
    const dateB = DateUtils.parse(b[attribute]);
    const dateA = DateUtils.parse(a[attribute]);
    return sortByDayAndMonthAndYear(dateA, dateB);
  }

  if (attribute === "collaboratorName") {
    if (b[attribute] < a[attribute]) {
      return -1;
    } else {
      return 1;
    }
  }

  return compareStrings(a[attribute], b[attribute]);
}

export function handleSortRequest(
  index,
  orderByIndex,
  setOrder,
  setOrderByIndex
) {
  const orderingSameColumn = index === orderByIndex;
  if (orderingSameColumn) {
    setOrder(prev =>
      prev === TableOrdering.ASC ? TableOrdering.DESC : TableOrdering.ASC
    );
  } else {
    setOrder(TableOrdering.ASC);
  }
  setOrderByIndex(index);
}
